import React from "react";
import "./weekCard.css";

import {
    Col,
    Card,
    CardText,
    CardBody,
    CardTitle,
    CardSubtitle
   
  } from "reactstrap";

const WeekCard = props => {
  const topics = props.topics;
  const listTopics = topics.map(topic => (
    <li key={topic} className="topic-names">
      {topic}
    </li>
  ));
  return (
    
        <Col
          sm={{ size: `${props.sm}` }}
          lg={{ size: `${props.lg}` }}
          className="pb-5 text-left cat"
          
        >
          <Card className="week-card  week-card-top h-100 border-0">
            <CardTitle className="week-num border-0">{props.title}</CardTitle>
            <hr className="week-underline " />
            <CardBody className="py-0 bottom-of-card  border-0">
              <CardSubtitle className="study-area pt-2 border-0">
                {props.subtitle}
              </CardSubtitle>
              <ul className="week-topics">{listTopics}</ul>
            </CardBody>
          </Card>
        </Col>
   
  );
};

export default WeekCard;
